import { useNavigate } from 'react-router';
import { useOnboardingStore } from '@/store/onboardingStore';
import { strings } from '@/theme';
import { Card, IconChip, Screen } from '../../ui';

/** Ported from src/app/(onboarding)/intent.tsx — the same two doors, same copy. */
export default function Intent() {
  const navigate = useNavigate();
  const setIntent = useOnboardingStore((s) => s.setIntent);
  const setPendingIntent = useOnboardingStore((s) => s.setPendingIntent);
  const setKind = useOnboardingStore((s) => s.setKind);
  const reset = useOnboardingStore((s) => s.reset);

  return (
    <Screen title={strings.onboarding.intentTitle}>
      <p className="type-body intent-sub">{strings.onboarding.intentSubtitle}</p>

      <Card
        className="intent-card"
        accessibilityLabel={strings.onboarding.buildCardTitle}
        onPress={() => {
          reset();
          setIntent('build');
          setKind('personal');
          navigate('/new/idea', { replace: true });
        }}
      >
        <IconChip icon="build" />
        <span className="type-heading">{strings.onboarding.buildCardTitle}</span>
        <span className="type-body intent-card-sub">{strings.onboarding.buildCardSub}</span>
      </Card>

      <Card
        className="intent-card"
        accessibilityLabel={strings.onboarding.browseCardTitle}
        onPress={() => {
          setPendingIntent('browse');
          setIntent('browse');
          navigate('/discover', { replace: true });
        }}
      >
        <IconChip icon="discover" />
        <span className="type-heading">{strings.onboarding.browseCardTitle}</span>
        <span className="type-body intent-card-sub">{strings.onboarding.browseCardSub}</span>
      </Card>
    </Screen>
  );
}
